export const TICKET_STATUS = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  RESPONDED: 'RESPONDED',
  RESOLVED: 'RESOLVED',
}

export const TICKET_TYPE = {
  NONDEL: 'NONDEL',
  EARLY: 'EARLY',
  LATE: 'LATE',
  DUMPING: 'DUMPING',
  MULTIPLE: 'MULTIPLE',
  EMPTY: 'EMPTY',
  NOCIRCS: 'NOCIRCS',
  ADDRESSED: 'ADDRESSED',
  OTHER: 'OTHER',
}

export const TICKET_TYPE_OPTIONS = [
  {
    id: TICKET_TYPE.NONDEL,
    label: 'Non Delivery',
  },
  {
    id: TICKET_TYPE.EARLY,
    label: 'Early Delivery',
  },
  {
    id: TICKET_TYPE.LATE,
    label: 'Late Delivery',
  },
  {
    id: TICKET_TYPE.DUMPING,
    label: 'Dumping',
  },
  {
    id: TICKET_TYPE.MULTIPLE,
    label: 'Multiple Delivery',
  },
  {
    id: TICKET_TYPE.EMPTY,
    label: 'Non Delivery - Empty Walk',
  },
  {
    id: TICKET_TYPE.NOCIRCS,
    label: 'Delivery To a No Circular Sign',
  },
  {
    id: TICKET_TYPE.ADDRESSED,
    label: 'Delivery To an Addressed Mail Only Sign',
  },
  {
    id: TICKET_TYPE.OTHER,
    label: 'Other',
  },
]

export const CREATE_TICKET_TYPE_OPTIONS = [
  {
    id: TICKET_TYPE.NONDEL,
    label: 'Non Delivery',
  },
  {
    id: TICKET_TYPE.EARLY,
    label: 'Early Delivery',
  },
  {
    id: TICKET_TYPE.LATE,
    label: 'Late Delivery',
  },
  {
    id: TICKET_TYPE.DUMPING,
    label: 'Dumping',
  },
  {
    id: TICKET_TYPE.MULTIPLE,
    label: 'Multiple Delivery',
  },
  {
    id: TICKET_TYPE.NOCIRCS,
    label: 'Delivery To a No Circular Sign',
  },
  {
    id: TICKET_TYPE.ADDRESSED,
    label: 'Delivery To an Addressed Mail Only Sign',
  },
  {
    id: TICKET_TYPE.OTHER,
    label: 'Other',
  },
]

export const JOB_START_DATE_OFFSET = 14 // Number of days prior to today when looking up jobs
export const DUMPING_JOB_START_DATE_OFFSET = 60
